import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    margin: '0.75rem 0px',
    alignItems: 'center',
    gridTemplateColumns: 'minmax(24px, auto) 120px auto'
  },
  avatar: {
    width: 24,
    height: 24
  },
  deleteBtn: {
    cursor: 'pointer'
  }
}))

export default useStyles
